import { createMuiTheme, responsiveFontSizes } from '@material-ui/core'

// A custom theme for this app
let theme = createMuiTheme({
  palette: {
    primary: {
      /*main: '#7DA1CA',*/
      /*main: '#007fa0',*/
      main: '#0099b9',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#78D64B',
      alt1: '#34A798', // teal
      alt2: '#DE7C00', // orange
      alt3: '#893B67', // purple
      alt4: '#FFC845', // yellow
      alt5: '#8F6A2A' // brown
    },
    tertiary: {
      main: '#164E71'
    },
    grey: {
      main: '#E6E7E9'
    },
    background: {
      default: '#F0F3FD'
    },
    text: {
      primary: '#797777'
    },
    error: {
      main: '#ff3d00'
    }
  },
  typography: {
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '1.5rem',
      fontWeight: '500',
      color:'#7DA1CA',
      lineHeight: '2rem',
      marginBottom:10
    },
    h2: {
      fontSize: '1.2rem',
      fontWeight: '300',
      lineHeight:'1.5rem',
      marginBottom:10
    },
    h3: {
      // fontFamily: 'Roboto',
      fontSize: '1rem',
      fontWeight: '300',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: '300'
    },
    h5: {
      fontSize: '1rem',
      fontWeight: '300'
    },
    h6: {
      fontSize: '1rem',
      fontWeight: '500',
      textTransform: 'inherit'
    },
    body:{
        fontSize: '1rem',
        fontWeight: '300'
    },
    body2: {
      fontSize: '1.25rem',
      fontWeight: '300',
    },
    caption: {
      fontSize: '1.125rem',
      fontWeight: '400',
      lineHeight: '1.5',
      display: 'block'
    }
  },
  overrides: {
    body:{
      backgroundColor: 'gray',
    },
    MuiPaper: {
      rounded: {
        borderRadius: '25px',
        padding: '15px',
      }
    },
    MuiButton: {
      root: {
        borderRadius: '12px',
        backgroundColor: '#97D700',
        color: 'white',
        textAlign: 'center',
        textTransform: 'inherit',
        '&:hover': {
          backgroundColor: '#6a8cb9',
          color: 'white'
        }
      },
      container: {
        width: '100%',
      },
      text: {
        padding: '8px 36px',
        fontWeight: '600',
        fontSize: '12px'
      }
    }
  }
})

//theme = responsiveFontSizes(theme)

export default theme
